import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55add963"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "auth-modal registration" }
const _hoisted_2 = { class: "auth-modal__inputs" }
const _hoisted_3 = { class: "xs-font-size items-in-line gap--5 flex-wrap flex-start" }
const _hoisted_4 = { class: "four-color xs-font-size" }
const _hoisted_5 = {
  key: 0,
  class: "ml--5 mr--5"
}
const _hoisted_6 = { class: "items-in-line gap--5 flex-end" }

import { computed, Ref, ref } from 'vue';
import { useVuelidate } from '@vuelidate/core';
import { email, required } from '@vuelidate/validators';
import { vMaska } from 'maska';
import { useAppStore } from '@/store/modules/app';
import {
  errorsHandler,
  errorsHandlerByKey,
  validationErrorsByRequest,
} from '@/utils/Common/Common';
import { ErrorsType, ValidateRulesType } from '@/types/MainPageTypes';
import { registrationApi } from '@/api/login';

type FormDataType = {
  phone: string | undefined;
  email: string | undefined;
  region_id: undefined | number;
  name: string | undefined;
  type_id: undefined | number;
  acceptanceOfTerms: undefined | boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'RegistrationModal',
  props: {
    showModal: { type: Boolean }
  },
  emits: ['close', 'showLoginModal', 'successRegistration'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const conditions = [
  'Пользователькое согл.',
  'Соглашение исп. сайта',
  'Маркетинговую рассылку',
  'Лицензионное соглашение',
  'Рекомендация технологии',
  'Обработка и расп. перс.данных',
];

const isLightRegistration = computed((): boolean => {
  return useAppStore().lightRegistration;
});

const formData: Ref<FormDataType> = ref({
  phone: undefined,
  email: undefined,
  region_id: undefined,
  name: undefined,
  type_id: undefined,
  acceptanceOfTerms: false,
});

const clearFormData = () => {
  v$.value.$reset();
  for (const [key] of Object.entries(formData)) {
    formData.value[key as keyof FormDataType] = undefined;
  }
};

const rules: ValidateRulesType = {
  phone: { required },
  email: { required, email },
  region_id: {},
  name: { required },
  type_id: { required },
  acceptanceOfTerms: { checked: (value: boolean | undefined) => value === true },
};
const v$ = useVuelidate<FormDataType>(rules, formData);

const errors: Ref<ErrorsType> = ref({});

const validationErrorsHandlerByKey = (key: string) => {
  let error: string | undefined = errorsHandlerByKey(key, rules, v$);

  if (error) {
    errors.value[key] = error;
  } else {
    delete errors.value[key];
  }
};
const validationErrorsHandler = () => {
  errors.value = errorsHandler(formData.value, rules, v$);
};

const loading = ref(false);
const formSubmit = async () => {
  if (v$.value.$invalid) {
    v$.value.$touch();
    validationErrorsHandler();

    return;
  }
  loading.value = true;
  const preparedFormData = {
    phone: formData.value.phone?.replace(/[^\d]/g, ''),
    email: formData.value.email,
    region_id: formData.value.region_id,
    name: formData.value.name,
    type_id: formData.value.type_id,
  };

  try {
    const res = await registrationApi(preparedFormData);

    if (res) {
      clearFormData();
      emit('successRegistration');
    }
  } catch (error) {
    errors.value = validationErrorsByRequest(error);
  } finally {
    loading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_base_input = _resolveComponent("base-input")!
  const _component_base_select_input = _resolveComponent("base-select-input")!
  const _component_base_form = _resolveComponent("base-form")!
  const _component_base_checkbox = _resolveComponent("base-checkbox")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createBlock(_component_base_modal, {
    "show-modal": _ctx.showModal,
    title: "Регистрация",
    onClose: _cache[17] || (_cache[17] = ($event: any) => (_ctx.$emit('close')))
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_base_form, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (!isLightRegistration.value)
                ? (_openBlock(), _createBlock(_component_base_input, {
                    key: 0,
                    modelValue: formData.value.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.name) = $event)),
                    error: errors.value.name,
                    invalid: !!errors.value.name,
                    height: "36",
                    label: "Имя",
                    onBlur: _cache[1] || (_cache[1] = ($event: any) => (validationErrorsHandlerByKey('name'))),
                    onFocus: _cache[2] || (_cache[2] = ($event: any) => (delete errors.value.name)),
                    onInput: _unref(v$).name.$touch
                  }, null, 8, ["modelValue", "error", "invalid", "onInput"]))
                : _createCommentVNode("", true),
              _withDirectives(_createVNode(_component_base_input, {
                modelValue: formData.value.phone,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.phone) = $event)),
                error: errors.value.phone,
                invalid: !!errors.value.phone,
                "data-maska": "(###)###-##-##",
                height: "36",
                label: "Телефон",
                placeholder: "(999)000-99-99",
                prefix: "+7 ",
                onBlur: _cache[4] || (_cache[4] = ($event: any) => (validationErrorsHandlerByKey('phone'))),
                onFocus: _cache[5] || (_cache[5] = ($event: any) => (delete errors.value.phone)),
                onInput: _unref(v$).phone.$touch
              }, null, 8, ["modelValue", "error", "invalid", "onInput"]), [
                [_unref(vMaska)]
              ]),
              _createVNode(_component_base_input, {
                modelValue: formData.value.email,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.email) = $event)),
                error: errors.value.email,
                invalid: !!errors.value.email,
                height: "36",
                label: "E-mail",
                onBlur: _cache[7] || (_cache[7] = ($event: any) => (validationErrorsHandlerByKey('email'))),
                onFocus: _cache[8] || (_cache[8] = ($event: any) => (delete errors.value.email)),
                onInput: _unref(v$).email.$touch
              }, null, 8, ["modelValue", "error", "invalid", "onInput"]),
              _createVNode(_component_base_select_input, {
                error: errors.value.type_id,
                modelValue: formData.value.type_id,
                options: _unref(useAppStore)().user_types,
                height: "36",
                label: "Роль",
                "text-key": "title",
                onBlur: _cache[9] || (_cache[9] = ($event: any) => (validationErrorsHandlerByKey('type'))),
                onFocus: _cache[10] || (_cache[10] = ($event: any) => (delete errors.value.type_id)),
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (formData.value.type_id = $event))
              }, null, 8, ["error", "modelValue", "options"]),
              (!isLightRegistration.value)
                ? (_openBlock(), _createBlock(_component_base_select_input, {
                    key: 1,
                    error: errors.value.region_id,
                    modelValue: formData.value.region_id,
                    options: _unref(useAppStore)().regions,
                    height: "36",
                    label: "Регион",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (formData.value.region_id = $event))
                  }, null, 8, ["error", "modelValue", "options"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createElementVNode("span", _hoisted_3, [
          _createElementVNode("span", null, [
            _createVNode(_component_base_checkbox, {
              modelValue: formData.value.acceptanceOfTerms,
              "onUpdate:modelValue": [
                _cache[13] || (_cache[13] = ($event: any) => ((formData.value.acceptanceOfTerms) = $event)),
                _cache[14] || (_cache[14] = ($event: any) => (delete errors.value.acceptanceOfTerms))
              ],
              error: errors.value.acceptanceOfTerms
            }, null, 8, ["modelValue", "error"])
          ]),
          _createElementVNode("button", {
            class: _normalizeClass({ 'error-color': errors.value.acceptanceOfTerms?.length }),
            onClick: _cache[15] || (_cache[15] = ($event: any) => (formData.value.acceptanceOfTerms = !formData.value.acceptanceOfTerms))
          }, " Принимаю условия ", 2),
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(conditions, (condition, i) => {
            return _createElementVNode("span", { key: i }, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(condition), 1),
              (i !== conditions.length - 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, "/"))
                : _createCommentVNode("", true)
            ])
          }), 64))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createTextVNode(" Уже есть аккаунт? "),
          _createElementVNode("button", {
            class: "gradient-color gradient-underline",
            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.$emit('showLoginModal')))
          }, " Войти ")
        ])
      ])
    ]),
    btn: _withCtx(() => [
      _createVNode(_component_base_button, {
        loading: loading.value,
        height: "40",
        text: "Зарегистрироваться",
        onClick: formSubmit
      }, null, 8, ["loading"])
    ]),
    _: 1
  }, 8, ["show-modal"]))
}
}

})